// extracted by mini-css-extract-plugin
module.exports = {"fill-parent":"fill-parent__XAu85","grid-bg":"grid-bg__2dlb8"};